// SPDX-License-Identifier: AGPL-3.0-or-later

import {ConfirmModal} from '@app/features/app/components/dialogs/ConfirmModal';
import {PREMIUM_PRODUCT_NAME} from '@app/features/app/config/I18nDisplayConstants';
import {Limits} from '@app/features/app/utils/UserLimits';
import {PremiumModal} from '@app/features/premium/components/modals/PremiumModal';
import {shouldShowPremiumFeatures} from '@app/features/premium/utils/PremiumUtils';
import {modal, push} from '@app/features/ui/commands/ModalCommands';
import Users from '@app/features/user/state/Users';
import {MAX_FAVORITE_MEMES_PREMIUM} from '@app/vendor/constants/LimitConstants';
import {plural} from '@lingui/core/macro';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
export const MaxFavoriteMemesModal = observer(() => {
	const {t} = useLingui();
	const currentUser = Users.currentUser;
	const showPremium = shouldShowPremiumFeatures();
	const premiumLimit = Limits.getPremiumValue('max_favorite_memes', MAX_FAVORITE_MEMES_PREMIUM);
	const maxFavoriteMemes = currentUser?.maxFavoriteMemes ?? premiumLimit;
	const canUpgradeFavoriteMemes = maxFavoriteMemes < premiumLimit;
	const freeItemsText = plural(
		{count: maxFavoriteMemes},
		{
			one: '# saved media item',
			other: '# saved media items',
		},
	);
	if (!showPremium) {
		return (
			<ConfirmModal
				title={t`Saved media limit reached`}
				description={t`You've reached the maximum limit of ${freeItemsText}. This limit is configured by your instance administrator.`}
				primaryText={t`Understood`}
				onPrimary={() => {}}
				secondaryText={false}
				hideCloseButton
			/>
		);
	}
	if (!canUpgradeFavoriteMemes) {
		const description = plural(
			{count: maxFavoriteMemes},
			{
				one: "You've reached the maximum limit of # saved media item. To add more, you'll need to remove some existing items from your collection.",
				other:
					"You've reached the maximum limit of # saved media items. To add more, you'll need to remove some existing items from your collection.",
			},
		);
		return (
			<ConfirmModal
				title={t`Saved media limit reached`}
				description={description}
				secondaryText={t`Close`}
				hideCloseButton
			/>
		);
	}
	const premiumItemsText = plural(
		{count: premiumLimit},
		{
			one: '# saved media item',
			other: '# saved media items',
		},
	);
	const freeDescription = t`You've reached the maximum limit of ${freeItemsText} for free users. Upgrade to ${PREMIUM_PRODUCT_NAME} to increase your limit to ${premiumItemsText}!`;
	return (
		<ConfirmModal
			title={t`Saved media limit reached`}
			description={freeDescription}
			primaryText={t`Upgrade to ${PREMIUM_PRODUCT_NAME}`}
			primaryVariant="primary"
			onPrimary={() => {
				window.setTimeout(() => {
					push(modal(() => <PremiumModal />));
				}, 0);
			}}
			secondaryText={t`Maybe Later`}
		/>
	);
});
